(function ($) {
  ehProductSkuV1 = {
    formatter: $('.eh-product-sku-v1')
  };

  Drupal.behaviors.ehProductSkuV1 = {
    get: function (key) {
      return ehProductSkuV1[key];
    },

    set: function (key, val) {
      ehProductSkuV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var parent = thisFormatter.closest('.eh-product');
        var color = parent.attr('data-bg-color');
        var image = thisFormatter.find('.product-image a');

        image.css('background-color', color);
        // Remove 'US' string from product price
        thisFormatter.find('.product-price').text(thisFormatter.find('.product-price').text().replace(/US/g, ''));

        // Implementing multi-colored swatches in multi-sku shades. DoneDone #156 - Taken from: product_content_hotlist_v1.js
        // This might be moved to more global location
        // Check if the SKU have more than 1 shade
        thisFormatter.each(function () {
          var pcgProductSku = $(this),
            shadeBox = pcgProductSku.find('.product-shade .shade-box'),
            skuShade = shadeBox.attr('data-skushade');

          if (skuShade !== undefined) {
            var shades = skuShade.split(',').length,
              shade = skuShade.split(',');

            if (shades === 1) {
              shadeBox.addClass('single-shade');
            } else {
            // If there are 2 or more shades add multi-shade class and hide shade-box
              shadeBox.addClass('multi-shade');
              $('.multi-shade').closest('.product-shade').addClass('multi-shade-parent');
              $('.multi-shade').hide();
              // Iterate through available shades and rebuild shade-box divs
              for (var i = 0; i < shades; i++) {
                pcgProductSku.find('.product-shade.multi-shade-parent').prepend('<div style="background-color: ' + shade[i] + '" class="shade-box single-shaded item-' + i + '"></div>');
                pcgProductSku.find('.product-shade.multi-shade-parent').find('.shade-box.single-shaded.item-0').addClass('first').css({ 'margin-right': '6px' });
                var width;

                // We don't know how many shades could be in a SKU
                // Let's deal with up to 5
                switch (shades) {
                  case 2:
                    width = '9px';
                    break;
                  case 3:
                    width = '6px';
                    break;
                  case 4:
                    width = '4px';
                    break;
                  case 5:
                    width = '3px';
                    break;
                  default:
                    width = '2px';
                }
                pcgProductSku.find('.product-shade.multi-shade-parent').find('.shade-box.single-shaded').css({
                  'width': width,
                  'margin-right': '1px'
                });
              }
            }
          }
        });
      });
    }
  };
})(jQuery);
